
export function useDataModelOperation(dataModelItem, operation) {
    return (dataModelItem)
        ? dataModelItem.operations[operation]
        : null;
}

export function useDataModelOperationDelete(dataModelItem) {
    return useDataModelOperation(dataModelItem, 'delete');
}

export function useDataModelOperationInsert(dataModelItem) {
    return useDataModelOperation(dataModelItem, 'insert');
}

export function useDataModelOperationUpdate(dataModelItem) {
    return useDataModelOperation(dataModelItem, 'update');
}
